import { AppError } from '@/shared/lib/appError'

const TECHNICAL_SNIPPET_MAX_CHARS = 260

const normalizeSnippet = (value: string): string =>
  value
    .replace(/\s+/g, ' ')
    .trim()
    .slice(0, TECHNICAL_SNIPPET_MAX_CHARS)

const readObjectField = (input: unknown, key: string): string | undefined => {
  if (!input || typeof input !== 'object') return undefined
  const rawValue = (input as Record<string, unknown>)[key]
  return typeof rawValue === 'string' && rawValue.trim() ? normalizeSnippet(rawValue) : undefined
}

const extractTechnicalSnippet = (error: unknown): string | undefined => {
  if (error instanceof AppError && error.cause) {
    const causeMessage = readObjectField(error.cause, 'message')
    const causeDetails = readObjectField(error.cause, 'details')
    const causeHint = readObjectField(error.cause, 'hint')
    const causeCode = readObjectField(error.cause, 'code')

    const composed = [causeMessage, causeDetails, causeHint, causeCode]
      .filter(Boolean)
      .join(' | ')
      .trim()
    if (composed) return normalizeSnippet(composed)
  }

  if (error instanceof Error && error.message.trim()) {
    return normalizeSnippet(error.message)
  }

  const objectMessage = readObjectField(error, 'message')
  const objectDetails = readObjectField(error, 'details')
  const objectHint = readObjectField(error, 'hint')
  const objectCode = readObjectField(error, 'code')
  const composed = [objectMessage, objectDetails, objectHint, objectCode]
    .filter(Boolean)
    .join(' | ')
    .trim()
  if (composed) return normalizeSnippet(composed)

  if (typeof error === 'string' && error.trim()) {
    return normalizeSnippet(error)
  }

  return undefined
}

export const toFriendlyErrorMessage = (
  error: unknown,
  fallbackFriendlyMessage: string,
): string => {
  if (error instanceof AppError && error.code === 'PASSKEY_CANCELLED') {
    return error.message.trim() || 'Operação cancelada.'
  }

  const friendlyMessage =
    error instanceof AppError && error.message.trim() ? error.message : fallbackFriendlyMessage
  const technicalSnippet = extractTechnicalSnippet(error)

  if (!technicalSnippet || technicalSnippet === friendlyMessage) {
    return friendlyMessage
  }

  return `${friendlyMessage}\nDetalhe técnico: ${technicalSnippet}`
}
